export const DEPTH_COLORS = [
  'rgba(59,130,246,0.06)',
  'rgba(16,185,129,0.06)',
  'rgba(245,158,11,0.06)',
  'rgba(239,68,68,0.06)',
  'rgba(139,92,246,0.06)',
  'rgba(236,72,153,0.06)',
];
